import { OrderProduct } from '../modules/orders/products/orderProducts.types';
import { AvailabilityEnum } from '../modules/products/ProductTypes';

interface BuildOrderProductUniqueIdentifierParams {
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId: string | null;
}

export const retrieveOrderProductFromUniqueIdentifier = (uniqueIdentifier: string) => {
  const regex = /^([^/]+)\/([^/]+)\/([^/]+)$/;
  const match = uniqueIdentifier.match(regex);

  if (!match) {
    return null;
  }

  const [_, productColorId, availabilityRaw, deliveryWindowRaw] = match;

  if (!Object.values(AvailabilityEnum).includes(availabilityRaw as AvailabilityEnum)) {
    return null;
  }

  return {
    productColorId,
    availability: availabilityRaw as AvailabilityEnum,
    deliveryWindowId: deliveryWindowRaw === 'null' ? undefined : deliveryWindowRaw,
  };
};

export const buildOrderProductUniqueIdentifier = ({
  productColorId,
  availability,
  deliveryWindowId,
}: BuildOrderProductUniqueIdentifierParams) => {
  return `${productColorId}/${availability}/${deliveryWindowId}`;
};

export const getOrderProductUniqueIdentifier = (
  orderProduct: Pick<OrderProduct, 'productColorId' | 'availability' | 'deliveryWindow'>,
) => {
  return buildOrderProductUniqueIdentifier({
    productColorId: orderProduct.productColorId,
    availability: orderProduct.availability,
    deliveryWindowId: orderProduct.deliveryWindow?.id ?? null,
  });
};
